<template>
  <!-- Document PiP 内容由 getDocumentHtml() 注入 -->
  <div style="display: none;"></div>
</template>

<script>
var SPEED_OPTIONS = [0.5, 0.75, 1, 1.25, 1.5, 2]
var MEDIA_READY_TIMEOUT_MS = 15000

/**
 * 录音画中画（Document Picture-in-Picture）
 * - 主页面 audio 出声；PiP 内 video 静音作时钟
 * - 自定义控件：播放 / 进度 / 倍速（无音量）
 */
export default {
  name: 'ViewAudioPip',
  props: {
    lyrics: {
      type: Array,
      default: function () { return [] }
    },
    currentLyricIndex: {
      type: Number,
      default: -1
    },
    audioSrc: {
      type: String,
      required: true
    }
  },

  data: function () {
    return {
      pipWindow: null,
      pipVideo: null,
      masterAudio: null,
      suppressMasterSync: false,
      ui: {
        playBtn: null,
        seek: null,
        timeCurrent: null,
        timeDuration: null,
        speedSelect: null
      }
    }
  },

  beforeDestroy: function () {
    this.teardownPipWindow()
  },

  methods: {
    escapeHtml: function (text) {
      return String(text == null ? '' : text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },

    formatTime: function (seconds) {
      var total = Math.max(0, Math.floor(Number(seconds) || 0))
      var m = Math.floor(total / 60)
      var s = total % 60
      return m + ':' + (s < 10 ? '0' : '') + s
    },

    normalizeSpeed: function (rate) {
      var value = Number(rate)
      if (!isFinite(value) || value <= 0) return 1
      var best = SPEED_OPTIONS[0]
      var bestDiff = Math.abs(best - value)
      for (var i = 1; i < SPEED_OPTIONS.length; i++) {
        var diff = Math.abs(SPEED_OPTIONS[i] - value)
        if (diff < bestDiff) {
          best = SPEED_OPTIONS[i]
          bestDiff = diff
        }
      }
      return best
    },

    getDocumentHtml: function () {
      return [
        '<style>',
        '*{box-sizing:border-box}',
        'body{margin:0;padding:0;background:#0b0d10;color:#f3f5f7;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;display:flex;flex-direction:column;height:100vh}',
        '.lyrics-container{flex:1;overflow:hidden;padding:24px 16px 12px;display:flex;flex-direction:column;align-items:center;justify-content:center;background:radial-gradient(120% 80% at 50% 0%,rgba(49,194,124,.12),transparent 55%),#0b0d10}',
        '.lyrics{text-align:center;transition:transform .3s;padding:0 8px;width:100%}',
        '.lyric-line{margin:10px 0;color:rgba(255,255,255,.38);font-size:15px;line-height:1.5;transition:color .2s ease,transform .2s ease}',
        '.lyric-line.active{color:#31c27c;font-size:16px;font-weight:600}',
        '.controls{padding:14px 16px 18px;border-top:1px solid rgba(255,255,255,.08);background:linear-gradient(180deg,#12151a 0%,#0d1014 100%)}',
        'video{display:none}',
        '.pip-progress-row{display:flex;align-items:center;gap:10px;margin-bottom:12px}',
        '.pip-time{font-size:11px;color:rgba(255,255,255,.55);font-variant-numeric:tabular-nums;letter-spacing:.02em;min-width:34px}',
        '.pip-time.is-duration{text-align:right}',
        '.pip-seek{-webkit-appearance:none;appearance:none;flex:1;min-width:0;height:4px;border-radius:999px;background:linear-gradient(to right,#31c27c 0%,#31c27c var(--progress,0%),rgba(255,255,255,.16) var(--progress,0%),rgba(255,255,255,.16) 100%);outline:none;cursor:pointer}',
        '.pip-seek::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:12px;height:12px;border-radius:50%;background:#fff;box-shadow:0 0 0 3px rgba(49,194,124,.28);cursor:pointer}',
        '.pip-seek::-moz-range-thumb{width:12px;height:12px;border:0;border-radius:50%;background:#fff;box-shadow:0 0 0 3px rgba(49,194,124,.28);cursor:pointer}',
        '.pip-bar{display:flex;align-items:center;justify-content:space-between;gap:12px}',
        '.pip-bar-left,.pip-bar-right{display:flex;align-items:center;gap:8px}',
        '.pip-play{width:40px;height:40px;border:0;border-radius:50%;background:#31c27c;color:#04140c;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 6px 16px rgba(49,194,124,.28);transition:transform .15s ease,filter .15s ease}',
        '.pip-play:hover{filter:brightness(1.06)}',
        '.pip-play:active{transform:scale(.96)}',
        '.pip-play svg{width:18px;height:18px;fill:currentColor}',
        '.pip-play[data-playing="false"] .icon-pause{display:none}',
        '.pip-play[data-playing="true"] .icon-play{display:none}',
        '.pip-play .icon-play{margin-left:2px}',
        '.pip-label{font-size:12px;color:rgba(255,255,255,.45)}',
        '.pip-speed{height:32px;min-width:78px;padding:0 28px 0 12px;border-radius:16px;border:1px solid rgba(255,255,255,.12);background:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 12 12\'%3E%3Cpath fill=\'%23aaaaaa\' d=\'M2.5 4.5L6 8l3.5-3.5\'/%3E%3C/svg%3E") right 10px center/12px no-repeat,rgba(255,255,255,.06);color:#fff;font-size:12px;font-weight:600;outline:none;cursor:pointer;-webkit-appearance:none;appearance:none}',
        '.pip-speed:hover{border-color:rgba(49,194,124,.55);background-color:rgba(49,194,124,.12)}',
        '.pip-speed option{color:#111;background:#fff}',
        '</style>',
        '<div class="lyrics-container"><div class="lyrics" id="pip-lyrics"></div></div>',
        '<div class="controls">',
        '<video id="pip-video" preload="auto"></video>',
        '<div class="pip-progress-row">',
        '<span class="pip-time" id="pip-time-current">0:00</span>',
        '<input id="pip-seek" class="pip-seek" type="range" min="0" max="0" step="0.1" value="0">',
        '<span class="pip-time is-duration" id="pip-time-duration">0:00</span>',
        '</div>',
        '<div class="pip-bar">',
        '<div class="pip-bar-left">',
        '<button type="button" class="pip-play" id="pip-play" data-playing="false" title="播放" aria-label="播放">',
        '<svg class="icon-play" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"></path></svg>',
        '<svg class="icon-pause" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 5h4v14H6zm8 0h4v14h-4z"></path></svg>',
        '</button>',
        '</div>',
        '<div class="pip-bar-right">',
        '<span class="pip-label">倍速</span>',
        '<select id="pip-speed" class="pip-speed" title="播放速度">',
        '<option value="0.5">0.5x</option>',
        '<option value="0.75">0.75x</option>',
        '<option value="1" selected>1.0x</option>',
        '<option value="1.25">1.25x</option>',
        '<option value="1.5">1.5x</option>',
        '<option value="2">2.0x</option>',
        '</select>',
        '</div>',
        '</div>',
        '</div>'
      ].join('')
    },

    resetUiRefs: function () {
      this.ui = {
        playBtn: null,
        seek: null,
        timeCurrent: null,
        timeDuration: null,
        speedSelect: null
      }
    },

    teardownPipWindow: function () {
      if (this.pipWindow) {
        try {
          this.pipWindow.close()
        } catch (e) {}
      }
      // pagehide 会清引用；这里再兜底一次（close 失败或未触发时）
      this.pipWindow = null
      this.pipVideo = null
      this.masterAudio = null
      this.resetUiRefs()
    },

    waitForMediaReady: function (media) {
      return new Promise(function (resolve, reject) {
        if (!media) {
          reject(new Error('pip media missing'))
          return
        }
        if (media.readyState >= 1) {
          resolve()
          return
        }
        var settled = false
        var timer = setTimeout(function () {
          if (settled) return
          settled = true
          cleanup()
          reject(new Error('pip media load timeout'))
        }, MEDIA_READY_TIMEOUT_MS)

        function cleanup () {
          clearTimeout(timer)
          media.removeEventListener('loadedmetadata', onLoaded)
          media.removeEventListener('error', onError)
        }
        function onLoaded () {
          if (settled) return
          settled = true
          cleanup()
          resolve()
        }
        function onError () {
          if (settled) return
          settled = true
          cleanup()
          reject(new Error('pip media load error'))
        }
        media.addEventListener('loadedmetadata', onLoaded)
        media.addEventListener('error', onError)
      })
    },

    seekTo: function (media, time) {
      return new Promise(function (resolve) {
        if (!media || !(time > 0) || !isFinite(time)) {
          resolve()
          return
        }
        var done = false
        function finish () {
          if (done) return
          done = true
          media.removeEventListener('seeked', onSeeked)
          clearTimeout(timer)
          resolve()
        }
        function onSeeked () { finish() }
        media.addEventListener('seeked', onSeeked)
        var timer = setTimeout(finish, 500)
        try {
          media.currentTime = time
        } catch (e) {
          finish()
        }
      })
    },

    setMasterCurrentTime: function (time) {
      if (!this.masterAudio || !isFinite(time)) return
      try {
        this.masterAudio.currentTime = time
      } catch (e) {}
    },

    setPlaybackRate: function (rate) {
      var value = this.normalizeSpeed(rate)
      if (this.pipVideo && this.pipVideo.playbackRate !== value) {
        this.pipVideo.playbackRate = value
      }
      if (this.masterAudio && this.masterAudio.playbackRate !== value) {
        this.masterAudio.playbackRate = value
      }
      if (this.ui.speedSelect && this.ui.speedSelect.value !== String(value)) {
        this.ui.speedSelect.value = String(value)
      }
    },

    withSuppressMasterSync: function (fn) {
      this.suppressMasterSync = true
      try {
        fn()
      } finally {
        this.suppressMasterSync = false
      }
    },

    updatePlayButton: function () {
      if (!this.ui.playBtn || !this.pipVideo) return
      var playing = !this.pipVideo.paused
      this.ui.playBtn.setAttribute('data-playing', playing ? 'true' : 'false')
      this.ui.playBtn.setAttribute('title', playing ? '暂停' : '播放')
      this.ui.playBtn.setAttribute('aria-label', playing ? '暂停' : '播放')
    },

    updateSeekProgress: function () {
      if (!this.ui.seek) return
      var max = Number(this.ui.seek.max) || 0
      var value = Number(this.ui.seek.value) || 0
      var percent = max > 0 ? (value / max) * 100 : 0
      this.ui.seek.style.setProperty('--progress', percent + '%')
    },

    updateTimeUi: function () {
      if (!this.pipVideo) return
      var current = this.pipVideo.currentTime || 0
      var duration = isFinite(this.pipVideo.duration) ? this.pipVideo.duration : 0
      if (this.ui.seek && !this.ui.seek._dragging) {
        this.ui.seek.max = duration || 0
        this.ui.seek.value = current
      }
      if (this.ui.timeCurrent) this.ui.timeCurrent.textContent = this.formatTime(current)
      if (this.ui.timeDuration) this.ui.timeDuration.textContent = this.formatTime(duration)
      this.updateSeekProgress()
    },

    bindUiControls: function () {
      var self = this
      var doc = this.pipWindow.document
      this.ui.playBtn = doc.getElementById('pip-play')
      this.ui.seek = doc.getElementById('pip-seek')
      this.ui.timeCurrent = doc.getElementById('pip-time-current')
      this.ui.timeDuration = doc.getElementById('pip-time-duration')
      this.ui.speedSelect = doc.getElementById('pip-speed')
      if (!this.ui.playBtn || !this.ui.seek || !this.ui.speedSelect) {
        throw new Error('pip controls missing')
      }

      this.ui.playBtn.addEventListener('click', function () {
        if (!self.pipVideo) return
        if (self.pipVideo.paused) {
          self.pipVideo.play().catch(function () {})
          if (self.masterAudio && self.masterAudio.paused) {
            self.masterAudio.play().catch(function () {})
          }
        } else {
          self.withSuppressMasterSync(function () {
            self.pipVideo.pause()
          })
          if (self.masterAudio && !self.masterAudio.paused) {
            self.masterAudio.pause()
          }
        }
        self.updatePlayButton()
      })

      this.ui.seek.addEventListener('pointerdown', function () {
        self.ui.seek._dragging = true
      })
      var endDrag = function () {
        if (!self.ui.seek) return
        self.ui.seek._dragging = false
      }
      this.ui.seek.addEventListener('pointerup', endDrag)
      this.ui.seek.addEventListener('pointercancel', endDrag)

      this.ui.seek.addEventListener('input', function () {
        if (!self.pipVideo || !self.ui.seek) return
        var time = Number(self.ui.seek.value)
        try {
          self.pipVideo.currentTime = time
        } catch (e) {}
        self.setMasterCurrentTime(time)
        self.updateTimeUi()
      })

      this.ui.speedSelect.addEventListener('change', function () {
        self.setPlaybackRate(self.ui.speedSelect.value)
      })
    },

    bindMasterSync: function () {
      var self = this
      if (!this.pipVideo) return

      this.pipVideo.addEventListener('pause', function () {
        self.updatePlayButton()
        if (self.suppressMasterSync) return
        if (self.masterAudio && !self.masterAudio.paused) {
          self.masterAudio.pause()
        }
      })

      this.pipVideo.addEventListener('play', function () {
        self.updatePlayButton()
        if (self.suppressMasterSync) return
        if (self.masterAudio && self.masterAudio.paused) {
          self.masterAudio.play().catch(function () {})
        }
      })

      this.pipVideo.addEventListener('seeked', function () {
        if (!self.pipVideo) return
        self.setMasterCurrentTime(self.pipVideo.currentTime)
        self.updateTimeUi()
      })

      this.pipVideo.addEventListener('timeupdate', function () {
        if (!self.pipVideo) return
        if (self.masterAudio && Math.abs(self.masterAudio.currentTime - self.pipVideo.currentTime) > 0.35) {
          self.setMasterCurrentTime(self.pipVideo.currentTime)
        }
        self.updateTimeUi()
        self.$emit('time-update', parseInt(self.pipVideo.currentTime * 1000, 10))
      })

      this.pipVideo.addEventListener('loadedmetadata', function () {
        self.updateTimeUi()
      })

      this.pipVideo.addEventListener('ratechange', function () {
        if (!self.pipVideo) return
        self.setPlaybackRate(self.pipVideo.playbackRate)
      })
    },

    bindWindowEvents: function () {
      var self = this
      this.pipWindow.addEventListener('pagehide', function () {
        var currentTime = self.pipVideo ? self.pipVideo.currentTime : 0
        if (self.pipVideo) {
          self.withSuppressMasterSync(function () {
            self.pipVideo.pause()
          })
        }
        self.pipWindow = null
        self.pipVideo = null
        self.masterAudio = null
        self.resetUiRefs()
        self.$emit('pip-closed', { currentTime: currentTime })
      })
    },

    setupPipVideo: function () {
      this.pipVideo = this.pipWindow.document.getElementById('pip-video')
      if (!this.pipVideo) throw new Error('pip video missing')
      this.pipVideo.muted = true
      this.pipVideo.defaultMuted = true
      this.pipVideo.volume = 0
      this.pipVideo.preload = 'auto'
      this.pipVideo.src = this.audioSrc
    },

    syncPlaybackState: function (wasPlaying, seekTime) {
      var self = this
      var initialRate = this.masterAudio ? this.masterAudio.playbackRate : 1
      this.setPlaybackRate(initialRate)

      var playPromise = null
      if (wasPlaying) {
        playPromise = this.pipVideo.play().catch(function () { return null })
      }

      return this.waitForMediaReady(this.pipVideo).then(function () {
        return self.seekTo(self.pipVideo, seekTime)
      }).then(function () {
        self.setMasterCurrentTime(seekTime)
        self.updateLyrics()
        self.updateTimeUi()
        self.updatePlayButton()

        if (!wasPlaying) {
          self.withSuppressMasterSync(function () {
            self.pipVideo.pause()
          })
          if (self.masterAudio && !self.masterAudio.paused) {
            self.masterAudio.pause()
          }
          self.updatePlayButton()
          return
        }

        return Promise.resolve(playPromise).then(function () {
          var chain = Promise.resolve()
          if (self.pipVideo.paused) {
            chain = self.pipVideo.play().catch(function () {})
          }
          return chain
        }).then(function () {
          if (self.masterAudio && self.masterAudio.paused) {
            return self.masterAudio.play().catch(function () {})
          }
        }).then(function () {
          self.updatePlayButton()
        })
      })
    },

    initPictureInPicture: function (options) {
      var self = this
      options = options || {}
      var wasPlaying = !!options.wasPlaying
      var seekTime = typeof options.currentTime === 'number' ? options.currentTime : 0
      this.masterAudio = options.masterAudio || null

      // 已有画中画时先关掉，避免重复窗口
      if (this.pipWindow) {
        this.teardownPipWindow()
      }

      return window.documentPictureInPicture.requestWindow({
        width: 420,
        height: 320
      }).then(function (pipWindow) {
        self.pipWindow = pipWindow
        self.pipWindow.document.body.innerHTML = self.getDocumentHtml()
        self.setupPipVideo()
        self.bindUiControls()
        self.bindWindowEvents()
        self.bindMasterSync()
        return self.syncPlaybackState(wasPlaying, seekTime)
      }).then(function () {
        return true
      }).catch(function (error) {
        console.error('画中画初始化失败:', error)
        self.teardownPipWindow()
        self.$emit('pip-error', error)
        return false
      })
    },

    updateLyrics: function () {
      if (!this.pipWindow) return
      var lyricsContainer = this.pipWindow.document.getElementById('pip-lyrics')
      if (!lyricsContainer) return

      var visibleLines = 5
      var currentIndex = this.currentLyricIndex
      var startIndex = Math.max(0, currentIndex - Math.floor(visibleLines / 2))
      var endIndex = Math.min(startIndex + visibleLines, this.lyrics.length)
      var half = Math.floor(visibleLines / 2)
      var html = ''
      var slice = this.lyrics.slice(startIndex, endIndex)
      for (var i = 0; i < slice.length; i++) {
        var lyric = slice[i] || {}
        var isActive = startIndex + i === currentIndex
        var minY = isActive ? (i - half) * 10 : 0
        var text = this.escapeHtml(lyric.onebest)
        html += '<div class="lyric-line' + (isActive ? ' active' : '') +
          '" style="transform: translateY(' + minY + 'px)">' + text + '</div>'
      }
      lyricsContainer.innerHTML = html
    }
  },

  watch: {
    currentLyricIndex: function () {
      this.updateLyrics()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/question-review/components/AnswerFileFullScreen/src/ViewAudioPip.vue